import { SimpleChanges } from '@angular/core';

const handleSimpleChanges = (changes: SimpleChanges, cb) => {
  for (const propName in changes) {
    if (Object.prototype.hasOwnProperty.call(changes, propName)) {
      cb(propName, changes[propName]);
    }
  }
};

export { handleSimpleChanges };
